import React from "react";
import { Fab, Box } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WHATSAPP_NUMBER = "6382585971";
const MESSAGE = "Hello from Zolang Website";

function WhatsAppFloatingButton() {
  const handleClick = () => {
    const url = `https://wa.me/91${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      MESSAGE
    )}`;
    window.open(url, "_blank");
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 2000,
      }}
    >
      <Fab
        onClick={handleClick}
        aria-label="WhatsApp"
        sx={{
          bgcolor: "#8b0000", // same red theme
          color: "#fff",
          width: 64,
          height: 64,
          boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
          "&:hover": {
            bgcolor: "#ff4d4d",
          },
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 34 }} />
      </Fab>
    </Box>
  );
}

export default WhatsAppFloatingButton;
